export default __webpack_public_path__ + "images/OB.d6be4d7.png";